import { render } from "./aboutUsHeader.vue?vue&type=template&id=447a5c68&scoped=true"
import script from "./aboutUsHeader.vue?vue&type=script&lang=js"
export * from "./aboutUsHeader.vue?vue&type=script&lang=js"

import "./aboutUsHeader.vue?vue&type=style&index=0&id=447a5c68&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447a5c68"]])

export default __exports__